/* N1 · Colecciones: línea "Tallas disponibles" calculada a partir de los productos reales.
   No hay que escribir tallas a mano en ninguna descripción: si mañana entra una talla nueva, aparece sola.
   07/10/2026 (multidioma fase 2, lote 3): funciona también con prefijo de idioma (/pt/collections/…, /en/collections/…);
   el título sale de window.N1T (n1.cat.sizes_avail).
   11/10/2026 (§4.2): cuando las colecciones incluyan productos agotados, solo cuentan las tallas de variantes disponibles
   (variant.available), para que «Tallas disponibles» no enseñe tallas que no se pueden comprar. */
(function(){
if(window.N1ColSizes)return;window.N1ColSizes=1;
var css='.n1-colsz{display:flex;flex-wrap:wrap;align-items:center;gap:.4rem;margin:.8rem 0 0}'
+'.n1-colsz b{font-size:.58rem;letter-spacing:.16em;text-transform:uppercase;font-weight:800;color:#8f8f8f;margin-right:.2rem}'
+'.n1-colsz i{font-style:normal;min-width:30px;height:30px;padding:0 .5rem;display:inline-flex;align-items:center;justify-content:center;border-radius:6px;border:1px solid rgba(255,255,255,.16);font-size:.76rem;font-weight:700;color:#fff}'
+'html[data-n1-theme="light"] .n1-colsz i{color:#101010;border-color:rgba(0,0,0,.16)}';
var st=document.createElement('style');st.textContent=css;(document.head||document.documentElement).appendChild(st);
var T=function(k,d){var v=window.N1T&&window.N1T[k];return (typeof v==='string'&&v&&!/translation missing/i.test(v))?v:d};
var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
function host(){
  return document.querySelector('.n1k-head .n1k-sub, .collection__description, .n1k-intro p, .n1k-head p');
}
function run(){
  var m=location.pathname.match(/\/collections\/([^\/?#]+)/);if(!m)return;
  var h=host();if(!h||h.dataset.n1sz)return;
  var handle=m[1];if(!handle)return;
  h.dataset.n1sz=1;
  fetch(ROOT+'collections/'+handle+'/products.json?limit=250',{credentials:'same-origin'})
    .then(function(r){return r.ok?r.json():null})
    .then(function(d){
      if(!d||!d.products)return;
      var set={};
      d.products.forEach(function(p){(p.variants||[]).forEach(function(v){
        if(v.available===false)return;
        [v.option1,v.option2,v.option3].forEach(function(o){
          if(o&&/^[0-9]{1,2}$/.test(String(o).trim()))set[parseInt(o,10)]=1;
        });
      })});
      var sizes=Object.keys(set).map(Number).sort(function(a,b){return a-b});
      if(!sizes.length)return;
      var box=document.createElement('div');box.className='n1-colsz';
      box.innerHTML='<b>'+T('n1.cat.sizes_avail','Tallas disponibles')+'</b>'+sizes.map(function(n){return '<i>'+n+'</i>'}).join('');
      h.parentNode.insertBefore(box,h.nextSibling);
    }).catch(function(){});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
addEventListener('load',run);setTimeout(run,900);setTimeout(run,2000);
})();
